import React, { useMemo } from 'react';
import { useController } from 'react-hook-form';
import { FIRSTDAY_OF_MONTH } from '../../utils/Constant';
import CDateRangePicker from '../CDateRangePicker';

function ControlledDateRangePicker({ control, name, label, onChange, date, defNull = false, ...props }) {
    const defaultValue = useMemo(() => {
        return defNull ? null : {
            startDate: date?.startDate ?? FIRSTDAY_OF_MONTH,
            endDate: date?.endDate ?? new Date()
        }
    }, [defNull, date]);
    const { field } = useController({ control, name, defaultValue })

    const _onChange = (date) => {
        if (onChange) onChange(onChange)
        field.onChange(date)
    }

    return (
        <CDateRangePicker
            {...props}
            label={label}
            startDate={field?.value?.startDate ?? undefined}
            endDate={field?.value?.endDate ?? undefined}
            onChange={_onChange}
            defNull={defNull}
        />
    );
}

export default ControlledDateRangePicker;